import React from 'react';
import { Container, Typography } from '@mui/material';
import ProtectedRoute from '../ProtectedRoute';

const AdminDashboard = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h3" component="h1" gutterBottom>
        Admin Dashboard
      </Typography>
      <Typography variant="body1">
        Welcome to the admin panel.
      </Typography>
    </Container>
  );
};

const ProtectedAdminDashboard = () => (
  <ProtectedRoute adminOnly>
    <AdminDashboard />
  </ProtectedRoute>
);

export default ProtectedAdminDashboard;